// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem 3rem;
  background-color: black;
  position: sticky;
  top: 0;
  z-index: 1;
}
.top-bar__profile-container {
  display: flex;
  flex-direction: row;
  gap: 3rem;
}
.top-bar__profile-container__admin-button, .top-bar__profile-container__button {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 500;
  width: 10rem;
  height: 2rem;
  border-radius: 0.5rem;
  background-color: white;
  color: black;
  border: none;
  cursor: pointer;
}
.top-bar__profile-container__admin-button {
  background-color: #4BABB9;
}
.top-bar__profile-container .selected {
  background-color: #EF936C;
}
.top-bar__profile-container__button-container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
.top-bar__profile-container__button-container__select {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 500;
  width: 10rem;
  height: 2rem;
  border-radius: 0.5rem;
  background-color: #EF936C;
  color: black;
  border: none;
  cursor: pointer;
}
.top-bar__profile-container__button-container__select option {
  background-color: white;
  color: black;
  padding: 8px 16px;
  text-align: center;
}
.top-bar__logo-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.top-bar__logo-container img {
  margin-right: 1rem;
}
.top-bar__logo-container__button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.4rem;
  width: 3.8rem;
  border: 1px solid white;
  border-radius: 0.5rem;
  color: white;
  font-size: 0.825rem;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/top-bar/top-bar.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAER;AAAQ;EAEI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AACZ;AAEQ;EACI,yBAAA;AAAZ;AAGQ;EACI,yBAAA;AADZ;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AADZ;AAGY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AADhB;AAGY;EACI,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AADhB;AAKI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAHR;AAIQ;EACI,kBAAA;AAFZ;AAIQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAFZ","sourcesContent":[".top-bar{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.2rem 3rem;\n    background-color: black;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    &__profile-container{\n        display: flex;\n        flex-direction: row;\n        gap: 3rem;\n\n        &__admin-button,\n        &__button{\n            display: flex;\n            justify-content: center;\n            align-items:center ;\n            font-size: 0.9rem;\n            font-weight: 500;\n            width: 10rem;\n            height: 2rem;\n            border-radius: 0.5rem;\n            background-color:white;\n            color: black;\n            border: none;\n            cursor: pointer;\n        }\n\n        &__admin-button{\n            background-color: #4BABB9;\n        }\n\n        .selected{\n            background-color: #EF936C;\n        }\n        &__button-container{\n            display: flex;\n            flex-direction: row;\n            gap: 1rem;\n\n            &__select{\n                display: flex;\n                justify-content: center;\n                align-items:center ;\n                font-size: 0.9rem;\n                font-weight: 500;\n                width: 10rem;\n                height: 2rem;\n                border-radius: 0.5rem;\n                background-color:#EF936C;\n                color: black;\n                border: none;\n                cursor: pointer;\n            }\n            &__select option{\n                background-color: white;\n                color: black;\n                padding: 8px 16px;\n                text-align: center;\n            }\n        }\n    }\n    &__logo-container{\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        img{\n            margin-right: 1rem;\n        }\n        &__button{\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            height: 1.4rem;\n            width: 3.8rem;\n            border: 1px solid white;\n            border-radius: 0.5rem;\n            color: white;\n            font-size: 0.825rem;\n            cursor: pointer;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
